import React from 'react'
import tw from 'twin.macro'
import type { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro'
import { StatusChip } from 'src/components/payments-ops/StatusChip'
import type { PartnerWallet } from 'src/interfaces/wallet'
import { formatCentsAsUsd } from 'src/utils/invoiceMoney'

/** The pinned bottom row's id — never a real partner id. */
export const WALLETS_TOTALS_ROW_ID = '__wallets_totals__'

const isTotalsRow = (row: PartnerWallet): boolean => {
  return row.partnerId === WALLETS_TOTALS_ROW_ID
}

export const walletColumns: Array<GridColDef<PartnerWallet>> = [
  {
    field: 'partnerName',
    headerName: 'Partner',
    flex: 1,
    minWidth: 180,
    renderCell: (params: GridRenderCellParams<PartnerWallet, string>) => {
      return (
        <span css={isTotalsRow(params.row) ? tw`font-semibold` : undefined}>{params.value}</span>
      )
    },
  },
  {
    field: 'partnerStatus',
    headerName: 'Partner status',
    width: 140,
    display: 'flex',
    renderCell: (params: GridRenderCellParams<PartnerWallet, string>) => {
      if (isTotalsRow(params.row)) {
        return null
      }

      return (
        <StatusChip
          label={params.value === 'deleted' ? 'Deleted' : 'Active'}
          tone={params.value === 'deleted' ? 'neutral' : 'success'}
        />
      )
    },
  },
  { field: 'virtualAccountName', headerName: 'Virtual account', flex: 1, minWidth: 180 },
  { field: 'virtualAccountNickName', headerName: 'Nickname', flex: 1, minWidth: 160 },
  { field: 'virtualAccountStatus', headerName: 'VA status', width: 130 },
  {
    field: 'totalBalance',
    headerName: 'Total balance',
    width: 150,
    align: 'right',
    headerAlign: 'right',
    valueFormatter: (value: number) => {
      return formatCentsAsUsd(value)
    },
  },
  {
    field: 'availableBalance',
    headerName: 'Available balance',
    width: 160,
    align: 'right',
    headerAlign: 'right',
    valueFormatter: (value: number) => {
      return formatCentsAsUsd(value)
    },
  },
]
